import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, catchError, of, switchMap, take, tap } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { AppState } from '../reducers';
import { Injectable } from '@angular/core';
import { User } from '../core/models/core.models';
import { UserService } from '../core/services/user.service';
import { selectUser } from '../core/reducers/index';
import { setAdminCurentUser } from './actions/admin-users.actions';

@Injectable({
  providedIn: 'root',
})
export class UserResolver implements Resolve<User> {
  constructor(
    private userService: UserService,
    private store: Store<AppState>,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<User | null> {
    const userId = route.paramMap.get('userId');

    if (route.data['createObject'] || !userId) {
      this.store.dispatch(setAdminCurentUser({ user: null }));
      return of(null); // Directly return null if no userId or creating a new user
    }

    return this.userService.fetchUser(userId).pipe(
      tap((user: User) => {
        this.store.dispatch(setAdminCurentUser({ user }));
      }),
      catchError((error) => {
        console.error('Failed to fetch user', error);
        this.store.dispatch(setAdminCurentUser({ user: null }));
        return of(null);
      }),
    );
  }
}
